import { makeApiCall } from "@swiggy-private/js-utils";
import { getUserHeaders } from "utils/headers";
import { INFLUENCER_WEB_API_HOST, LOG_TABLES } from "constants/api";
import { sendNRApiEventsViaBlaze } from "utils/newRelic";
import { authInterceptor } from "utils/authInterceptor";
import { checkAndHandle401 } from "utils/authUtils";

export interface IOptions extends RequestInit {
    searchParams?: {
        [key: string]: string;
    };
}

// Authentication endpoints that should not trigger logout on 401
const AUTH_ENDPOINTS = [
    '/v2/accounts/sendVerificationCode',
    '/v1/accounts/signInWithOTP'
];

// Check if the endpoint is an authentication endpoint
const isAuthEndpoint = (endpoint: string): boolean => {
    return AUTH_ENDPOINTS.some(authEndpoint => endpoint.includes(authEndpoint));
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const customApiCall = async (apiHost: string, apiEndpoint: string, opts?: IOptions): Promise<any> => {
    const userHeaders = getUserHeaders();

    // Get valid token (will auto-refresh if needed)
    const accessToken = await authInterceptor.getValidToken();

    const authHeaders = accessToken ? { "x-oztok": accessToken, "ozone-enabled": true } : {};

    const options: IOptions = {
        ...opts,
        headers: {
            ...userHeaders,
            ...authHeaders,
            ...opts?.headers,
        } as HeadersInit,
    };

    const decideRetryBasedOnStatus = (response: { statusCode?: number }): boolean => {
        if (response) return false;
        return true;
    };

    try {
        const response = await makeApiCall(
            {
                apiHost: apiHost,
                endpoint: apiEndpoint,
                options,
                searchParams: options.searchParams,
                shouldRetry: decideRetryBasedOnStatus,
            },
            userHeaders || {},
            sendNRApiEventsViaBlaze,
            LOG_TABLES,
        );

        return response;
    } catch (error) {
        // Only check for 401 unauthorized error and handle logout for non-auth endpoints
        if (!isAuthEndpoint(apiEndpoint) && checkAndHandle401(error)) {
            // Throw a specific error to indicate user was logged out
            throw new Error('Unauthorized - user logged out');
        }

        // Re-throw other errors
        throw error;
    }
};

export const getApiHost = () => INFLUENCER_WEB_API_HOST === "/" ? "" : INFLUENCER_WEB_API_HOST;

export const getGeneralizeUrl = (url: string): string => {
    const trimLength = url.indexOf("?");
    url = url.substring(0, trimLength !== -1 ? trimLength : url.length);
    const urlArray = url.split("/");
    const params = ["users", "conversations"];
    let replace = false;
    const generalizedUrlArray = urlArray.map((item) => {
        if (replace) {
            replace = false;
            return ":id";
        }
        if (params.includes(item)) {
            replace = true;
        }
        return item;
    });
    return generalizedUrlArray.join("/");
};
